import { Typography } from "antd"

import { dateTimeFormat } from "@src/shared/date"

type Props = {
  value?: string
}

export const DateTimeTableCell = ({ value }: Props) => {
  if (!value) return null

  const formatted = dateTimeFormat(value)
  const [date, time] = formatted.includes(",")
    ? formatted.split(",").map((part) => part.trim())
    : formatted.split(/\s+(?=\S+$)/)

  return (
    <Typography.Text
      style={{
        display: "inline-flex",
        flexDirection: "column",
        lineHeight: 1.35,
        whiteSpace: "nowrap",
      }}
    >
      <span>{date}</span>
      {time && <span>{time}</span>}
    </Typography.Text>
  )
}
